export default __webpack_public_path__ + "static/media/restrict.acd896dd.svg";